import { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import NutriLineChart from "./components/NutriLineChart";

const Widget3 = ({ data }) => {
  const { t } = useTranslation();
  if (!data) return null;

  const institutionalLowBirthWeightRate =
    +data.institutionalLowBirthWeightRate?.[0]?.[1] || 0;
  const institutionalOverBirthWeightRate =
    +data.institutionalOverBirthWeightRate?.[0]?.[1] || 0;
  const childrenAdmittedForSAMTreatment = data.childrenAdmittedForSAMTreatment;

  // sort by childrenAdmittedForSAMTreatment.metaData.dimensions.pe
  const childrenAdmittedForSAMTreatmentData =
    data?.childrenAdmittedForSAMTreatment?.rows?.sort()?.map((row) => row[2]) ||
    [];

  // mYEIKaiIelR
  //const vitaminASupplementation = data.vitaminASupplementation?.[0]?.[2] || 0;

  // const institutionalLowBirthWeightRate = 6;
  // const institutionalOverBirthWeightRate = 1;
  // const childrenAdmittedForSAMTreatment = 850;
  console.log({ childrenAdmittedForSAMTreatment });
  return (
    <div style={{ display: "flex", gap: 10 }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        <div style={{ display: "flex", gap: 10, minHeight: 150 }}>
          <Box
            sx={{
              padding: { xs: "0 5px", md: "20px 20px" },
              display: "flex",
              border: "1px solid #31589d",
              alignItems: "center",
              gap: 2,
              width: 280,
            }}
          >
            <div style={{ fontSize: 40, fontWeight: "bold" }}>
              {institutionalLowBirthWeightRate.toFixed(0)}%
            </div>
            <div style={{ fontSize: 20, fontWeight: "bold" }}>
              {t("Institutional low birth weight rate")}
            </div>
          </Box>
          <Box
            sx={{
              padding: { xs: "0 5px", md: "20px 20px" },
              display: "flex",
              alignItems: "center",
              border: "1px solid #31589d",
              gap: 2,
              width: 280,
            }}
          >
            <div style={{ fontSize: 40, fontWeight: "bold" }}>
              {institutionalOverBirthWeightRate.toFixed(0)}%
            </div>
            <div style={{ fontSize: 20, fontWeight: "bold" }}>
              {t("Institutional over birth weight rate")}
            </div>
          </Box>
        </div>
        <div style={{ display: "flex", gap: 10, minHeight: 150 }}>
          <Box
            sx={{
              padding: { xs: "0 5px", md: "20px 20px" },
              display: "flex",
              border: "1px solid #31589d",
              alignItems: "center",
              gap: 2,
              width: 280,
            }}
          >
            <div style={{ fontSize: 40, fontWeight: "bold" }}>
              {/* {((vitaminASupplementation / 785637) * 100).toFixed(0)}% */}
              61%
            </div>
            <div
              style={{
                fontSize: 20,
                fontWeight: "bold",
                wordBreak: "break-all",
              }}
            >
              {t("Vitamin-A supplementation")}
            </div>
          </Box>
          <Box
            sx={{
              padding: { xs: "0 5px", md: "20px 20px" },
              display: "flex",
              alignItems: "center",
              border: "1px solid #31589d",
              gap: 2,
              width: 280,
            }}
          >
            <div style={{ fontSize: 40, fontWeight: "bold" }}>
              {/* {institutionalOverBirthWeightRate.toFixed(0)}% */}
              6%
            </div>
            <div style={{ fontSize: 20, fontWeight: "bold" }}>
              {t("Deworming")}
            </div>
          </Box>
        </div>
      </div>

      {/* childrenAdmittedForSAMTreatment */}
      {childrenAdmittedForSAMTreatment ? (
        <div
          style={{
            minWidth: 500,
            width: "100%",
            height: 353,
          }}
        >
          <NutriLineChart
            title={t("Children admitted for SAM treatment")}
            data={{
              labels: childrenAdmittedForSAMTreatment.metaData.dimensions.pe,
              datasets: [
                {
                  data: childrenAdmittedForSAMTreatmentData,
                  borderColor: "#31589d",
                  background: "#31589d",
                },
              ],
            }}
          />
        </div>
      ) : null}
    </div>
  );
};

export default Widget3;
